import script from "./NoteIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteIcon.vue?vue&type=script&setup=true&lang=js"

import "./NoteIcon.vue?vue&type=style&index=0&id=844af86c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-844af86c"]])

export default __exports__